<template>
  <div class="container">
    <!-- 商户报单信息 -->
    <div class="card-wrapper">
      <el-card shadow="hover" class="card">
        <div slot="header" class="clearfix">
          <span>商户报单信息：</span>
        </div>
        <div class="card-content">
          <el-row :gutter="20">
            <el-col :span="8"
              ><strong>客户姓名：</strong>{{ info.customName }}</el-col
            >
            <el-col :span="8"
              ><strong>客户手机号：</strong>{{ info.customMobile }}</el-col
            >
            <el-col :span="8"
              ><strong>客户地址：</strong>{{ info.customAddress }}</el-col
            >
          </el-row>
        </div>
      </el-card>
    </div>

    <!-- 提货商品列表 -->
    <div class="card-wrapper">
      <el-card shadow="hover" class="card">
        <div slot="header" class="clearfix">
          <span>提货商品列表：</span>
        </div>
        <div class="card-content">
          <div
            v-for="(group, freq) in goodsList"
            :key="freq"
            class="goods-group"
          >
            <div class="group-header">
              <h4 class="group-title">
                第{{ freq }}次提货--{{ group.warehouseName }}前仓
                <el-tag
                  v-if="group.isWaitForDelivery"
                  type="warning"
                  size="small"
                  >待提货</el-tag
                >
                <el-tag v-else type="success" size="small">已提货</el-tag>
              </h4>
              <p class="pickup-time">
                <strong>提货时间：</strong>{{ group.pickUpTime || "—" }}
              </p>
            </div>

            <!-- 商品表格 -->
            <el-table
              :data="group.items"
              border
              style="width: 100%; margin-bottom: 16px"
            >
              <el-table-column prop="name" label="商品名称"></el-table-column>
              <el-table-column prop="num" label="数量"></el-table-column>
            </el-table>

            <!-- 签名图片行 -->
            <div class="signatures">
              <div class="signature-item">
                <p class="signature-label">商家签名：</p>
                <img
                  v-if="group.shopSignPic"
                  :src="group.shopSignPic"
                  alt="商家签名照片"
                />
                <el-button v-else type="info" size="mini" disabled
                  >暂无照片</el-button
                >
              </div>
              <div class="signature-item">
                <p class="signature-label">工程师签名：</p>
                <img
                  v-if="group.consigneeSignPic"
                  :src="group.consigneeSignPic"
                  alt="工程师签名照片"
                />
                <el-button v-else type="info" size="mini" disabled
                  >暂无照片</el-button
                >
              </div>
            </div>
          </div>
        </div>
        <!-- 返回按钮 -->
        <div class="card-wrapper return-btn">
          <el-button
            type="danger"
            size="small"
            @click="goBack"
            icon="el-icon-circle-close-outline"
            >返回</el-button
          >
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { getEliveryOrder } from "@/api/work/eliveryOrder";
import { findPureWaterGoodsByRootDepartId } from "@/api/salesCloud/goodsQr";

export default {
  data() {
    return {
      info: {},
      goodsList: [],
      type: null,
    };
  },
  async created() {
    const { id, type } = this.$route.query;
    this.type = type;
    if (id) {
      const res = await getEliveryOrder(id, type);
      if (res.code !== "200") return this.$message.error(res.message);
      const raw = JSON.parse(res.data).rows[0];
      const consigneePics = raw.consigneeSignPic
        ? raw.consigneeSignPic.split(",")
        : [];
      const shopPics = raw.shopSignPic ? raw.shopSignPic.split(",") : [];
      this.info = { ...raw };
      this.info.list = raw.list.map((item) => {
        const idx = (item.frequency || 1) - 1;
        return {
          ...item,
          pickUpTime: item.pickUpTime,
          consigneeSignPic: consigneePics[idx] || "",
          shopSignPic: shopPics[idx] || "",
        };
      });
      this.loadGoods(this.info.list);
    }
  },
  methods: {
    async loadGoods(selectedList) {
      const res = await findPureWaterGoodsByRootDepartId(this.type);
      if (res.code !== "200") return this.$message.error(res.message);
      const data = JSON.parse(res.data) || [];
      const grouped = selectedList.reduce((acc, item) => {
        const freq = item.frequency || 1;
        if (!acc[freq]) {
          acc[freq] = {
            ...item, // 保留原始数据..
            frequency: freq,
            pickUpTime: this.formatDate(item.pickUpTime),
            isWaitForDelivery: !item.pickUpTime,
            items: [],
            consigneeSignPic: item.consigneeSignPic,
            shopSignPic: item.shopSignPic,
          };
        }
        data.forEach((goods) => {
          goods.filters
            .filter((f) => f.id === item.goodsId)
            .forEach((f) => {
              acc[freq].items.push({
                name: `${goods.name}-${f.value}`,
                num: item.num,
              });
            });
        });
        return acc;
      }, {});
      this.goodsList = grouped;
      console.log(this.goodsList);
      
    },
    goBack() {
      this.$store.commit("DEL_TAG", {
        close: true,
        label: "编辑商户报单",
        value: "/work/waterProject/merchants/edit",
      });
      this.$router.go(-1);
    },
    formatDate(ts) {
      if (!ts) return "";
      const d = new Date(ts);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
        2,
        "0"
      )}-${String(d.getDate()).padStart(2, "0")} ${String(
        d.getHours()
      ).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
    },
  },
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  font-family: fangsong;
  font-size: 16px;
}
.card-wrapper {
  width: 100%;
}
.card {
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.card-content {
  padding: 20px;
}
.goods-group {
  margin-bottom: 24px;
}
.group-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.pickup-time {
  margin: 0;
  font-weight: bold;
}
.signatures {
  display: flex;
  gap: 40px;
}
.signature-item {
  flex: 1;
  text-align: center;
}
.signature-label {
  margin-bottom: 8px;
  font-weight: bold;
}
.signature-item img {
  max-width: 100%;
  height: 80px;
  object-fit: contain;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 5px;
}
.return-btn {
  text-align: center;
  margin-bottom: 20px;
}
</style>
